
import respUtility from '~/mixins/respUtility';
import ReviewsViewTabSectionMainContent from './TabSection/MainContent.vue';
import ReviewsViewTabSectionTopContent from './TabSection/TopContent.vue';

export default {
  name: 'ReviewsViewTabSection',
  mixins: [respUtility],
  components: {
    ReviewsViewTabSectionMainContent,
    ReviewsViewTabSectionTopContent,
  },
  props: {
    reviewItems: {
      type: Array,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
  },
  computed: {
    totalVisible() {
      return !(this.$device.isMobileOrTablet || this.isTouchDevice) ? 7 : 6;
    },
    currentPage: {
      get() {
        return Number(this.page) || 1;
      },
      async set(newPage) {
        if (newPage === this.page) {
          return;
        }
        if (newPage !== 1) {
          this.$router.push({
            ...this.$route,
            query: {
              ...this.$route.query,
              p: newPage,
            },
          });
        } else {
          const { p, ...otherQueryParams } = this.$route.query;
          this.$router.push({
            ...this.$route,
            query: otherQueryParams,
          });
        }
        this.$store.dispatch('reviews/updatePage', newPage);
        this.$emit('changeReviewsList');
      },
    },
  },
};
